export const getDateString = (date: string | Date) =>
	date instanceof Date
		? date.toLocaleString()
		: new Date(date + 'Z').toLocaleString();
